


































/** @format */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { deleteInvoiceAPI, getInvoiceAllListAPI, getInvoiceListAPI } from '@/api/setting-management';

// import { deleteInvoiceAPI, getInvoiceListAPI } from '@/common/api/smart-parking/setting-management'

@Component({
  components: {
    InvoiceSettingTable: () => import('./components/invoiceSettingTable.vue'),
    InvoiceSettingEdit: () => import('./components/invoiceSettingEdit.vue')
  }
})
export default class InvoiceSettingList extends Vue {
  /**
   * 初始化参数-用于初始化表单，比如重置查询
   */
  private initParams: any = {
    organId: '',
    currPage: 1,
    pageSize: 20
  };
  // 查询参数
  private filterParams: any = {};
  // 列表数据是否在加载
  private listLoading: boolean = false;
  // 列表数据总条数
  private totalCount: number = 0;
  // 列表数据
  private listData: any = [];

  // 编辑输入框信息
  private editInfo: any = {
    visible: false, // 是否显示
    detailInfo: {}
  };

  // 机构ID
  @Prop({ type: String, default: '' })
  organizationId!: string;

  // 初始化参数到查询参数
  @Watch('initParams', { deep: true, immediate: true })
  onChangeInitParams(newVal: any, oldVal: any) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.filterParams)) {
      this.filterParams = JSON.parse(JSON.stringify(newVal));
    }
  }

  // 初始化参数到查询参数
  @Watch('organizationId', {})
  onChangeOrganizationId(newVal: string, oldVal: string) {
    this.initData();
  }

  // 如果列表数据为空，默认显示新增表单
  @Watch('listData', { deep: true })
  onChangeListData(newVal: any[], oldVal: any[]) {
    if (newVal.length === 0) {
      this.editInfo.visible = true;
    }
    // this.$emit('on-invoice-change', newVal)
  }

  // 重置查询参数
  resetSearchData(params: any) {
    this.filterParams = {
      ...JSON.parse(JSON.stringify(this.initParams)),
      ...params
    };
  }

  // 编辑－显示弹出框
  handleEditShow(data: any) {
    this.editInfo.visible = true;
    this.editInfo.detailInfo = data;
  }

  // 取消编辑
  handleCancel(isUpdate: boolean) {
    const { listData } = this;
    this.editInfo.visible = listData.length === 0;
  }

  // 添加成功
  handleCreated() {
    this.editInfo.visible = false;
    this.handleInitList({
      currPage: 1
    });
  }

  // 编辑成功
  handleUpdated() {
    this.editInfo.visible = false;
    this.handleInitList();
  }

  // 删除
  async handleDelete(data: any) {
    await this.deleteInvoiceData(data.pkInvoiceId || '');
    this.handleInitList({
      currPage: 1
    });
  }

  // 初始化列表
  handleInitList(params: any = {}) {
    this.filterParams = {
      ...this.filterParams,
      ...params
    };
    this.getListData();
  }

  // 删除数据
  async deleteInvoiceData(invoiceId: string) {
    try {
      this.listLoading = true;
      //deleteInvoiceAPI
      const { status, code, msg, data = {} } = await deleteInvoiceAPI({
        pkInvoiceId: invoiceId
      });
      if (status === '9999') {
        this.$message.success(data || '删除成功！');
      } else {
        this.$message.error(msg || '删除失败！');
      }
    } catch (error) {
      // console.log(error)
      this.$message.error((error && error.msg) || '删除失败！');
    } finally {
      this.listLoading = false;
    }
  }

  // 获取列表数据
  async getListData() {
    try {
      if (this.listLoading) return;
      this.listLoading = true;
      const { organizationId, currPage, pageSize } = this.filterParams;
      //getInvoiceListAPI

      const { status, code, msg, data = {} } = await getInvoiceListAPI({
        organId: organizationId,
        currPage,
        pageSize
      });
      if (status === '9999') {
        const { totalNum, datas } = data;
        this.listData = datas;
        this.totalCount = Number(totalNum);
      } else {
        this.$message.error(msg || '获取列表失败！');
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.listLoading = false;
    }
  }

  // 初始化数据
  async initData() {
    const { organizationId } = this;
    this.resetSearchData({
      organizationId: organizationId
    });
    await this.getListData();
  }

  // 生命周期初始化
  async created() {
    await this.initData();
  }
}
